
import $ from "jquery";
import { nextTick } from "vue";
// import { getWeather } from "@/apis/envmonitor.ts";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
} from "vue";
import ran from "./rain.vue"; // 雨
import clound from "./cloud.vue"; //  云
import snow from "./snow.vue"; //  雪
import sunny from "./sunny.vue"; //  晴
import { getWeather, queryEnvCurrent } from "@/apis/envmonitor";
import { formatEnergyDate, getWeek } from "@/utils";
import { useRouter } from "vue-router";
export default defineComponent({
  components: {
    ran,
    clound,
    snow,
    sunny,
  },
  setup(props) {
    const router = useRouter();
    let weatherData: any = [
      {
        text: "云",
        type: "clound",
        logonIcon: "阴.png",
      },
      {
        text: "雨",
        type: "rain",
        logonIcon: "雨.png",
      },
      {
        text: "雪",
        type: "snow",
        logonIcon: "雪.png",
      },
      {
        text: "晴",
        type: "sunny",
        logonIcon: "晴.png",
      },
    ];
    let times: any = null;
    let currentData: any = [];
    let envObj: any = {
      Tdb: "0", // 温度
      RH: "0", //湿度
      HCHO: "0", //甲醛
      PM2d5: "0",
    };
    let intevell: any = null;
    let timer: any = null;
    const proxyData = reactive({
      weatherData: weatherData,
      envObj: envObj,
      temperature: "",
      weatherKey: "",
      logonIcon: "阴.png",
      currentData: currentData,
      nowTime: formatEnergyDate()[2],
      sTime: formatEnergyDate(2)[2],
      nowDate: formatEnergyDate()[0],
      intevell: intevell,
      week: getWeek(),
      // 设置现在时间
      setNowDate() {
        proxyData.intevell = setInterval(() => {
          let timeArr: any = formatEnergyDate();
          proxyData.nowTime = timeArr[2];
          proxyData.nowDate = timeArr[0];
          let timeArr1: any = formatEnergyDate(2);
          proxyData.sTime = timeArr1[2];
          proxyData.week = getWeek();
        }, 1000);
      },
      // 设置天气key的值
      setWeatherKey(content: any) {
        if (content.code <= 8) {
          proxyData.weatherKey = "sunny";
          proxyData.logonIcon = "晴.png";
        } else if (content.code >= 10 && content.code <= 19) {
          proxyData.weatherKey = "rain";
          proxyData.logonIcon = "雨.png";
        } else if (content.code >= 20 && content.code <= 25) {
          proxyData.weatherKey = "snow";
          proxyData.logonIcon = "雪.png";
        } else {
          if (content.code == "38") {
            proxyData.weatherKey = "sunny";
            proxyData.logonIcon = "晴.png";
          } else {
            proxyData.weatherKey = "clound";
            proxyData.logonIcon = "阴.png";
          }
        }
      },
      // 获取天气数据
      getWeatherData() {
        getWeather().then((res) => {
          let resResult: any = res;
          let content: any = resResult.content;
          proxyData.temperature = content.temperature;
          proxyData.setWeatherKey(content);
        });
      },
      timer: timer,
      setTimer(timeLen: any = 600000) {
        proxyData.timer = setInterval(() => {
          proxyData.setEnvData();
          proxyData.queryEnvCurrent();
        }, timeLen);
      },
      // 设置环境数据
      setEnvData() {
        proxyData.envObj = {
          Tdb: "0", // 温度
          RH: "0", //湿度
          HCHO: "0", //甲醛
          PM2d5: "0",
        };
        proxyData.currentData.map((item: any) => {
          if (item.code == "Tdb") {
            item.data = item.data ? item.data.toFixed(1) : "--";
          } else if (item.code == "RH") {
            item.data = item.data ? item.data.toFixed(0) : "--";
          } else if (item.code == "PM2d5") {
            item.data = item.data ? item.data.toFixed(0) : "--";
          } else {
            item.data = item.data ? item.data.toFixed(2) : "--";
          }

          proxyData.envObj[item.code] = item.data;
        });
      },
      // 获取环境数据
      queryEnvCurrent() {
        queryEnvCurrent()
          .then((res) => {
            let resResult: any = res;
            if (resResult.result == "success") {
              proxyData.currentData = resResult.data || [];
            } else {
              proxyData.currentData = [];
            }
            proxyData.setEnvData();
          })
          .catch((error: any) => {
            proxyData.currentData = [];
          });
      },
      times: times,
      changePage() {
        proxyData.times = setTimeout(() => {
          clearTimeout(proxyData.times);
          // router.push({ path: "/home" });
          window.location.href = "/sk/home";
        }, 300000);
      },
    });
    onBeforeUnmount(() => {
      clearInterval(proxyData.intevell);
      clearInterval(proxyData.timer);
      clearTimeout(proxyData.times);
    });
    onMounted(() => {
      proxyData.setNowDate();
      // 获取天气数据
      proxyData.getWeatherData();
      // 获取环境数据
      proxyData.queryEnvCurrent();
      proxyData.changePage();
      // proxyData.setTimer();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
